export const FIELD_LABELS: Record<string, string> = {
  agents: "Agents",
  "agents.defaults": "Agent Defaults",
  "agents.defaults.workspace": "Workspace",
  "agents.defaults.model": "Default Model",
  "agents.defaults.engine": "Default Runtime",
  "agents.defaults.engineConfig": "Default Runtime Config",
  "agents.defaults.thinkingDefault": "Default Thinking",
  "agents.defaults.models": "Model Strategy Overrides",
  "agents.defaults.contextTokens": "Context Tokens",
  "agents.defaults.reservedContextTokens": "Reserved Context Tokens",
  "agents.defaults.maxToolIterations": "Max Tool Iterations",
  "agents.list": "Agent List",
  "agents.list.*.id": "Agent ID",
  "agents.list.*.default": "Default Agent",
  "agents.list.*.workspace": "Workspace Override",
  "agents.list.*.model": "Model Override",
  "agents.list.*.engine": "Runtime Override",
  "agents.list.*.engineConfig": "Runtime Config Override",
  "agents.list.*.thinkingDefault": "Thinking Override",
  "agents.list.*.models": "Model Strategy Overrides",
  "agents.list.*.contextTokens": "Context Tokens Override",
  "agents.list.*.reservedContextTokens": "Reserved Context Tokens Override",
  "agents.list.*.maxToolIterations": "Tool Iterations Override",
  "agents.context": "Context",
  "agents.context.bootstrap": "Bootstrap Files",
  "agents.context.bootstrap.files": "Bootstrap Files",
  "agents.context.bootstrap.minimalFiles": "Minimal Files",
  "agents.context.bootstrap.perFileChars": "Max Chars per File",
  "agents.context.bootstrap.totalChars": "Total Bootstrap Chars",
  "agents.context.memory": "Memory",
  "agents.context.memory.enabled": "Enable Memory",
  "agents.context.memory.maxChars": "Max Memory Chars",
  "agents.learningLoop": "Learning Loop",
  "agents.learningLoop.enabled": "Enable Learning Loop",
  "agents.learningLoop.toolCallThreshold": "Learning Loop Tool Threshold",
  "bindings": "Bindings",
  "bindings.*.agentId": "Target Agent",
  "bindings.*.match.channel": "Match Channel",
  "bindings.*.match.accountId": "Match Account ID",
  "bindings.*.match.peer.kind": "Match Peer Kind",
  "bindings.*.match.peer.id": "Match Peer ID",
  "session": "Session",
  "session.dmScope": "DM Scope",
  providers: "Providers",
  "providers.*.displayName": "Provider Display Name",
  "providers.*.apiKey": "API Key",
  "providers.*.apiBase": "API Base URL",
  "providers.*.extraHeaders": "Extra Headers",
  "providers.*.wireApi": "Wire API Mode",
  "providers.*.models": "Custom Models",
  "providers.*.modelConfig": "Model Capability Config",
  search: "Search",
  "search.provider": "Active Search Provider",
  "search.enabledProviders": "Enabled Search Providers",
  "search.defaults": "Search Defaults",
  "search.defaults.maxResults": "Default Search Results",
  "search.providers": "Search Provider Settings",
  "search.providers.bocha": "Bocha Search",
  "search.providers.bocha.apiKey": "Bocha API Key",
  "search.providers.bocha.baseUrl": "Bocha API Base URL",
  "search.providers.bocha.summary": "Enable Summary",
  "search.providers.bocha.freshness": "Freshness Window",
  "search.providers.bocha.docsUrl": "Bocha Docs URL",
  "search.providers.brave": "Brave Search",
  "search.providers.brave.apiKey": "Brave API Key",
  "search.providers.brave.baseUrl": "Brave API Base URL",
  "search.providers.tavily": "Tavily Search",
  "search.providers.tavily.apiKey": "Tavily API Key",
  "search.providers.tavily.baseUrl": "Tavily API Base URL",
  "search.providers.tavily.searchDepth": "Search Depth",
  "search.providers.tavily.includeAnswer": "Include Answer",
  channels: "Channels",
  gateway: "Gateway",
  "gateway.host": "Gateway Host",
  "gateway.port": "Gateway Port",
  ui: "UI",
  "ui.enabled": "Enable UI",
  "ui.host": "UI Host (Read-only)",
  "ui.port": "UI Port",
  "ui.open": "Open Browser",
  "ui.auth": "UI Authentication",
  "ui.auth.enabled": "Enable UI Authentication",
  "ui.auth.username": "Admin Username",
  "ui.auth.passwordHash": "Password Hash",
  "ui.auth.passwordSalt": "Password Salt",
  remote: "Remote Access",
  "remote.enabled": "Enable Remote Access",
  "remote.deviceName": "Remote Device Name",
  "remote.platformApiBase": "Remote Platform API Base",
  "remote.autoReconnect": "Remote Auto Reconnect",
  tools: "Tools",
  "tools.web": "Web Tools",
  "tools.web.search": "Web Search",
  "tools.web.search.apiKey": "Search API Key",
  "tools.web.search.maxResults": "Max Results",
  "tools.exec": "Command Execution",
  "tools.exec.timeout": "Exec Timeout (seconds)",
  "tools.restrictToWorkspace": "Restrict Tools to Workspace",
  secrets: "Secrets",
  "secrets.enabled": "Enable Secrets",
  "secrets.defaults": "Secret Provider Defaults",
  "secrets.defaults.env": "Default Env Provider",
  "secrets.defaults.file": "Default File Provider",
  "secrets.defaults.exec": "Default Exec Provider",
  "secrets.providers": "Secret Providers",
  "secrets.providers.*.source": "Secret Provider Source",
  "secrets.providers.*.prefix": "Env Prefix",
  "secrets.providers.*.path": "Secret File Path",
  "secrets.providers.*.format": "Secret File Format",
  "secrets.providers.*.command": "Secret Command",
  "secrets.providers.*.args": "Secret Command Args",
  "secrets.providers.*.cwd": "Secret Command CWD",
  "secrets.providers.*.timeoutMs": "Secret Command Timeout (ms)",
  "secrets.refs": "Secret References",
  "secrets.refs.*.source": "Secret Source",
  "secrets.refs.*.provider": "Secret Provider",
  "secrets.refs.*.id": "Secret ID",
  "channels.whatsapp": "WhatsApp",
  "channels.whatsapp.enabled": "Enabled",
  "channels.whatsapp.bridgeUrl": "Bridge URL",
  "channels.whatsapp.allowFrom": "Allow From",
  "channels.telegram": "Telegram",
  "channels.telegram.enabled": "Enabled",
  "channels.telegram.token": "Bot Token",
  "channels.telegram.allowFrom": "Allow From",
  "channels.telegram.proxy": "Proxy",
  "channels.telegram.ackReaction": "Ack Reaction Emoji",
  "channels.telegram.ackReactionScope": "Ack Reaction Scope",
  "channels.telegram.accountId": "Account ID",
  "channels.telegram.dmPolicy": "DM Policy",
  "channels.telegram.groupPolicy": "Group Policy",
  "channels.telegram.groupAllowFrom": "Group Allow From",
  "channels.telegram.streaming": "Streaming Mode",
  "channels.telegram.requireMention": "Require Mention",
  "channels.telegram.mentionPatterns": "Mention Patterns",
  "channels.telegram.groups": "Group Rules",
  "channels.discord": "Discord",
  "channels.discord.enabled": "Enabled",
  "channels.discord.token": "Bot Token",
  "channels.discord.allowBots": "Allow Bot Messages",
  "channels.discord.allowFrom": "Allow From",
  "channels.discord.gatewayUrl": "Gateway URL",
  "channels.discord.intents": "Gateway Intents",
  "channels.discord.proxy": "HTTP Proxy",
  "channels.discord.mediaMaxMb": "Attachment Max Size (MB)",
  "channels.discord.streaming": "Streaming Mode",
  "channels.discord.draftChunk": "Draft Chunking",
  "channels.discord.draftChunk.minChars": "Draft Min Chars",
  "channels.discord.draftChunk.maxChars": "Draft Max Chars",
  "channels.discord.draftChunk.breakPreference": "Draft Break Preference",
  "channels.discord.textChunkLimit": "Text Chunk Limit",
  "channels.discord.accountId": "Account ID",
  "channels.discord.dmPolicy": "DM Policy",
  "channels.discord.groupPolicy": "Group Policy",
  "channels.discord.groupAllowFrom": "Group Allow From",
  "channels.discord.requireMention": "Require Mention",
  "channels.discord.mentionPatterns": "Mention Patterns",
  "channels.discord.groups": "Group Rules",
  "channels.feishu": "Feishu",
  "channels.feishu.enabled": "Enabled",
  "channels.feishu.appId": "App ID",
  "channels.feishu.appSecret": "App Secret",
  "channels.feishu.encryptKey": "Encrypt Key",
  "channels.feishu.verificationToken": "Verification Token",
  "channels.feishu.domain": "Domain",
  "channels.feishu.allowFrom": "Allow From",
  "channels.feishu.dmPolicy": "DM Policy",
  "channels.feishu.groupPolicy": "Group Policy",
  "channels.feishu.groupAllowFrom": "Group Allow From",
  "channels.feishu.requireMention": "Require Mention",
  "channels.feishu.mentionPatterns": "Mention Patterns",
  "channels.feishu.groups": "Group Rules",
  "channels.feishu.accounts": "Accounts",
  "channels.dingtalk": "DingTalk",
  "channels.dingtalk.enabled": "Enabled",
  "channels.dingtalk.clientId": "Client ID",
  "channels.dingtalk.clientSecret": "Client Secret",
  "channels.dingtalk.allowFrom": "Allow From",
  "channels.wecom": "WeCom",
  "channels.wecom.enabled": "Enabled",
  "channels.wecom.corpId": "Corp ID",
  "channels.wecom.agentId": "Agent ID",
  "channels.wecom.secret": "App Secret",
  "channels.wecom.token": "Callback Token",
  "channels.wecom.callbackPort": "Callback Port",
  "channels.wecom.callbackPath": "Callback Path",
  "channels.wecom.allowFrom": "Allow From",
  "channels.slack": "Slack",
  "channels.slack.enabled": "Enabled",
  "channels.slack.mode": "Mode",
  "channels.slack.webhookPath": "Webhook Path",
  "channels.slack.botToken": "Bot Token",
  "channels.slack.appToken": "App Token",
  "channels.slack.allowBots": "Allow Bot Messages",
  "channels.slack.userTokenReadOnly": "User Token Read Only",
  "channels.slack.groupPolicy": "Group Policy",
  "channels.slack.groupAllowFrom": "Group Allow From",
  "channels.slack.dm": "DM",
  "channels.slack.dm.enabled": "Enabled",
  "channels.slack.dm.policy": "DM Policy",
  "channels.slack.dm.allowFrom": "Allow From",
  "channels.email": "Email",
  "channels.email.enabled": "Enabled",
  "channels.email.imapHost": "IMAP Host",
  "channels.email.imapPort": "IMAP Port",
  "channels.email.imapUsername": "IMAP Username",
  "channels.email.imapPassword": "IMAP Password",
  "channels.email.smtpHost": "SMTP Host",
  "channels.email.smtpPort": "SMTP Port",
  "channels.email.smtpUsername": "SMTP Username",
  "channels.email.smtpPassword": "SMTP Password",
  "channels.email.fromAddress": "From Address",
  "channels.email.pollIntervalSeconds": "Poll Interval (seconds)",
  "channels.email.maxBodyChars": "Max Body Chars",
  "channels.email.subjectPrefix": "Subject Prefix",
  "channels.email.allowFrom": "Allow From",
  "channels.qq": "QQ",
  "channels.qq.enabled": "Enabled",
  "channels.qq.appId": "App ID",
  "channels.qq.secret": "App Secret",
  "channels.qq.markdownSupport": "Markdown Support",
  "channels.qq.allowFrom": "Allow From"
};
